var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.1403 9.55026C23.0407 9.40625 22.9076 9.28855 22.7525 9.20723C22.5974 9.12591 22.425 9.0834 22.2498 9.08334H7.44392L6.19375 6.0825C6.02983 5.68733 5.75226 5.34973 5.39623 5.1125C5.0402 4.87527 4.62174 4.74911 4.19392 4.75H1.6665V6.91667H4.19392L9.33325 19.2504C9.41557 19.4478 9.55444 19.6163 9.73238 19.7349C9.91031 19.8534 10.1194 19.9167 10.3332 19.9167H18.9998C19.4516 19.9167 19.8557 19.6361 20.0149 19.2147L23.2649 10.548C23.3263 10.384 23.3471 10.2076 23.3254 10.0338C23.3037 9.86003 23.2402 9.69411 23.1403 9.55026V9.55026ZM18.2491 17.75H11.0558L8.34742 11.25H20.6866L18.2491 17.75Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.875 24.25C11.7725 24.25 12.5 23.5225 12.5 22.625C12.5 21.7275 11.7725 21 10.875 21C9.97754 21 9.25 21.7275 9.25 22.625C9.25 23.5225 9.97754 24.25 10.875 24.25Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4585 24.25C19.356 24.25 20.0835 23.5225 20.0835 22.625C20.0835 21.7275 19.356 21 18.4585 21C17.561 21 16.8335 21.7275 16.8335 22.625C16.8335 23.5225 17.561 24.25 18.4585 24.25Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/cart.212e5ce8347de7324eb3a5c68703e9ab.svg";
export { ForwardRef as ReactComponent };